import React, { useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { ArrowRight, Mail, CheckCircle2 } from "lucide-react";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_cercle-local-bhealth/artifacts/csfd9ojj_logofinal-logo-full-color-rgb-900px-w-72ppi.png";

export default function ForgotPasswordPage({ merchantMode = false }) {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setDone(true);
    } catch {
      toast.error("Erreur — réessayez");
    } finally { setBusy(false); }
  };

  const backPath = merchantMode ? "/partenaire/login" : "/admin/login";

  return (
    <div className="min-h-screen grid place-items-center bg-muted p-6">
      <div className="w-full max-w-md bg-white rounded-3xl shadow-[0_20px_50px_-15px_rgba(11,18,32,0.15)] p-8 md:p-10">
        <Link to="/" className="flex items-center gap-3 mb-8">
          <img src={LOGO_URL} alt="B.health®" className="h-10 w-10 object-contain" />
          <div className="font-heading font-extrabold uppercase tracking-wider text-sm text-navy-900">Local Benefits</div>
        </Link>

        {done ? (
          <>
            <div className="w-16 h-16 rounded-full bg-lime-500 mx-auto flex items-center justify-center mb-5">
              <CheckCircle2 className="w-8 h-8 text-navy-900" />
            </div>
            <h2 className="font-heading font-extrabold text-3xl text-navy-900 text-center tracking-tighter">Email envoyé</h2>
            <p className="text-muted-foreground mt-2 text-center text-sm leading-relaxed">
              Si un compte existe pour <span className="text-navy-900 font-semibold">{email}</span>, vous allez recevoir un lien de réinitialisation dans quelques instants. Vérifiez votre boîte de réception (et les spams).
            </p>
            <Link to={backPath} className="btn-navy w-full mt-6" data-testid="forgot-back-login">
              Retour à la connexion <ArrowRight className="w-4 h-4" />
            </Link>
          </>
        ) : (
          <>
            <div className="inline-flex items-center gap-2 text-xs uppercase tracking-widest text-navy-900/60 font-semibold mb-3">
              <Mail className="w-3.5 h-3.5" /> Mot de passe oublié
            </div>
            <h2 className="font-heading font-extrabold text-3xl text-navy-900 tracking-tighter">Réinitialisation</h2>
            <p className="mt-2 text-muted-foreground text-sm">Entrez votre email, nous vous enverrons un lien de réinitialisation valable 60 minutes.</p>
            <form onSubmit={submit} className="mt-6 space-y-4" data-testid="forgot-form">
              <div>
                <Label className="text-xs uppercase tracking-wider font-semibold text-navy-900/70">Email</Label>
                <Input data-testid="forgot-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="mt-1.5 h-12" />
              </div>
              <button type="submit" disabled={busy} className="btn-navy w-full h-12" data-testid="forgot-submit">
                {busy ? "Envoi…" : "Envoyer le lien"} <ArrowRight className="w-4 h-4" />
              </button>
              <div className="text-center text-xs">
                <Link to={backPath} className="text-navy-900/60 hover:text-navy-900">Retour à la connexion</Link>
              </div>
            </form>
          </>
        )}
      </div>
    </div>
  );
}
